/* Elec'Clim+ — interactions du thème */
(function () {
  'use strict';

  /* Menu mobile */
  function initNav() {
    var burger = document.querySelector('[data-burger]');
    var nav = document.getElementById('SiteNav');
    if (!burger || !nav || burger.dataset.ready) return;
    burger.dataset.ready = '1';

    function close() {
      nav.classList.remove('open');
      burger.setAttribute('aria-expanded', 'false');
    }
    burger.addEventListener('click', function () {
      var open = nav.classList.toggle('open');
      burger.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
    nav.addEventListener('click', function (e) {
      if (e.target.closest('a')) close();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') close();
    });
  }

  /* Apparition des blocs au défilement */
  var observer = null;
  function initReveal() {
    var items = document.querySelectorAll('.reveal:not(.in)');
    if (!items.length) return;
    var designMode = window.Shopify && window.Shopify.designMode;
    if (designMode || !('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('in'); });
      return;
    }
    if (!observer) {
      observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('in');
            observer.unobserve(entry.target);
          }
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    }
    items.forEach(function (el) { observer.observe(el); });
  }

  /* Après l'envoi du formulaire de devis, on ramène le visiteur dessus */
  function initFormFocus() {
    var msg = document.querySelector('[data-form-status]');
    if (msg) {
      msg.setAttribute('tabindex', '-1');
      msg.scrollIntoView({ block: 'center' });
      msg.focus({ preventScroll: true });
    }
  }

  /* Bouton d'appel flottant (mobile) : affiché une fois le haut de page passé */
  function initFloatCall() {
    var btn = document.querySelector('.float-call');
    if (!btn || btn.dataset.ready) return;
    btn.dataset.ready = '1';
    var ticking = false;
    function update() {
      ticking = false;
      btn.classList.toggle('show', window.scrollY > 420);
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; window.requestAnimationFrame(update); }
    }, { passive: true });
    update();
  }

  function init() {
    initNav();
    initReveal();
    initFloatCall();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); initFormFocus(); });
  } else {
    init();
    initFormFocus();
  }

  /* Éditeur de thème Shopify : les sections sont rechargées à chaud */
  document.addEventListener('shopify:section:load', init);
})();
